import * as actions from "./hotelType";
import { ProcessType, HotelSettings } from "./hotelType";

export const requestHotelProfile = (
  propcode?: string
): actions.HotelPropRequest => ({
  type: actions.HOTEL_PROP_REQUEST,
  payload: propcode ,
});

export const setHotelPropCode = (
  propCode: string|null
): actions.HotelSetPropCode => ({
  type: actions.HOTEL_SET_PROP_CODE,
  payload: propCode
})

export const setHotelProfileSuccess = (
  data: any
): actions.HotelPropSuccess => ({
  type: actions.HOTEL_PROP_SUCCESS,
  payload: data,
});

export const setHotelSettings = (
  settings: HotelSettings
): actions.HotelSettingsSuccess => ({
  type: actions.HOTEL_SETTINGS_SUCCESS,
  payload: settings,
});

export const requestHotelPaymentCodeList = (
  propCode?: string | null
): actions.HotelPaymentCodeListRequest => ({
  type: actions.HOTEL_PAYMENT_CODE_LIST_REQUEST,
  payload: propCode,
});

export const setHotelPaymentCodeListSuccess = (
  options: actions.PaymentCodeOption[]
): actions.HotelPaymentCodeListSuccess => ({
  type: actions.HOTEL_PAYMENT_CODE_LIST_SUCCESS,
  payload: options,
});

export const setHotelPaymentCodeListFailure = (
  message: string
): actions.HotelPaymentCodeListFailure => ({
  type: actions.HOTEL_PAYMENT_CODE_LIST_FAILURE,
  payload: message,
});

export const setHotelProfileProcessStatus = (
  process: ProcessType
): actions.HotelPropProcessStatus => ({
  type: actions.HOTEL_PROP_PROCESS_STATUS,
  payload: process,
});

export const resetHotelProfile = (): actions.HotelPropReset => ({
  type: actions.HOTEL_PROP_RESET,
});

export const requestHotelSettingUpdate = (
  settings: Partial<HotelSettings>
): actions.HotelSettingUpdateRequest => ({
  type: actions.HOTEL_SETTING_UPDATE_REQUEST,
  payload: settings,
});

export const setHotelSettingUpdateSuccess = (
  settings: HotelSettings
): actions.HotelSettingUpdateSuccess => ({
  type: actions.HOTEL_SETTING_UPDATE_SUCCESS,
  payload: settings,
});

export const setHotelSettingUpdateFailure = (
  message: string
): actions.HotelSettingUpdateFailure => ({
  type: actions.HOTEL_SETTING_UPDATE_FAILURE,
  payload: message,
});

export const clearHotelProfileProcess = (): actions.HotelProfileClearProcess => ({
  type: actions.HOTEL_PROFILE_CLEAR_PROCESS,
});

export const requestHotelChannelList = (
  propCode?: string | null,
): actions.HotelChannelListRequest => ({
  type: actions.HOTEL_CHANNEL_LIST_REQUEST,
  payload: propCode,
});

export const setHotelChannelListSuccess = (
  options: actions.ChannelOption[],
): actions.HotelChannelListSuccess => ({
  type: actions.HOTEL_CHANNEL_LIST_SUCCESS,
  payload: options,
});

export const setHotelChannelListFailure = (
  message: string,
): actions.HotelChannelListFailure => ({
  type: actions.HOTEL_CHANNEL_LIST_FAILURE,
  payload: message,
});
